/*
 * The contact-person dropdown's options (#300).
 *
 * A Zoho client can hold two contacts with the same name - the customer's example was two people
 * called "Ric Cairns" - and a list of names then collapses them into one entry that tells whoever
 * is filling in the form nothing. Where a name repeats, the email disambiguates it; a name that
 * appears once is left alone, so the ordinary case still reads "Greg Lucas".
 *
 * The job's `contactPerson` is a plain string and is only ever displayed, so the label chosen here
 * is what gets stored. That makes a duplicate pair genuinely distinguishable, and leaves every
 * unique name exactly as it was.
 */
// Collapsed as well as trimmed: Zoho data arrives with stray spaces, and a name is also the key the
// duplicates are grouped by, so "Ric  Cairns" must not count as a different person.
const displayName = contact => `${contact.firstName || ''} ${contact.lastName || ''}`.replace(/\s+/g, ' ').trim()

export const contactLabels = (contacts = []) => {
  const named = (contacts || [])
    .map(contact => ({ name: displayName(contact || {}), email: (contact || {}).email }))
    .filter(contact => contact.name)

  const counts = named.reduce((totals, contact) => {
    totals[contact.name] = (totals[contact.name] || 0) + 1
    return totals
  }, {})

  const labels = named.map(contact =>
    counts[contact.name] > 1 && contact.email ? `${contact.name} (${contact.email})` : contact.name
  )

  // A duplicate pair with no email on either contact cannot be told apart, which is the old
  // behaviour rather than a new failure - but it must not produce two identical options either,
  // because the select keys off the label.
  return [...new Set(labels)].sort()
}
